import React from 'react';

export const BreadcrumbsContext = React.createContext({
  items: [],
  parentPath: '',
  path: '',
});
